/**
 * Root App Component
 *
 * Sets up the application with:
 * - React Query for server state management
 * - React Router for routing
 * - i18n for internationalization
 *
 * @module App
 */

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '@/lib/react-query';
import AppRouter from '@/routes';
import '@/lib/i18n'; // Initialize i18n

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function App() {
  const { i18n } = useTranslation();

  //Todo: change it to useQuery separated from App.tsx
  
  useEffect(() => {
    // Invalidate all queries when language changes to fetch new translations
    const handleLanguageChange = () => {
      queryClient.invalidateQueries();
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  return (
    <QueryClientProvider client={queryClient}>
      <AppRouter />
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}

export default App;